import Chart from "chart.js";
import chartElevationLabel from "./chartElevationLabel";
import chartDistanceProfileLabel from "./chartDistanceProfileLabel";

export default function (id, climbData, day, level) {
  let climb = climbData[id];

  if (!climb || !climb.profile) {
    return;
  }

  if (!climb.chart || climb.chart.canvas.id !== `chart-climb-${id}-${day}--${level}`) {
    var cw = $(".box-climb-view").width() - 75;
    var d = `#chart-climb-${id}-${day}--${level}`;
    $(d).attr("width", cw);
    climb.chart = new Chart($(d)[0], {
      type: "line",
      data: {
        datasets: [
          {
            label: "Elevation",
            data: climb.profile,
            borderColor: "rgba(34, 68, 132, 1)",
            pointRadius: 0,
            borderWidth: 0,
          },
        ],
      },
      options: {
        maintainAspectRatio: true,
        animation: {
          duration: 200, // general animation time
        },
        hover: {
          animationDuration: 0, // duration of animations when hovering an item
        },
        responsiveAnimationDuration: 0,
        legend: {
          display: false,
        },
        elements: {
          line: {
            showLine: true,
            spanGaps: true,
            tension: 0, // disables bezier curves
          },
        },
        scales: {
          yAxes: [
            {
              type: "linear",
              position: "right",
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                z: 1,
                color: "rgba(200, 200, 200, 0.5)",
              },
              ticks: {
                fontColor: "rgba(100, 100, 100, 1)",
                fontFamily: "Suisse",
                callback: chartElevationLabel,
              },
            },
          ],
          xAxes: [
            {
              afterTickToLabelConversion: function (scaleInstance) {
                scaleInstance.ticks[0] = "";
                scaleInstance.ticks[scaleInstance.ticks.length - 1] = "";
              },
              type: "linear",
              gridLines: {
                display: true,
                drawTicks: true,
                drawBorder: false,
                drawOnChartArea: false,
                tickMarkLength: 5,
              },
              ticks: {
                display: true,
                fontColor: "rgba(100, 100, 100, 1)",
                fontFamily: "Suisse",
                max: climb.profile[climb.profile.length - 1].x,
                maxRotation: 0,
                callback: chartDistanceProfileLabel,
              },
            },
          ],
        },
      },
      plugins: [
        {
          beforeRender: function (x) {
            var c = x.chart;
            var dataset = x.data.datasets[0];

            var gradientFill = c.ctx.createLinearGradient(0, 0, c.width, 0);
            for (let index = 0; index < dataset.data.length - 1; index++) {
              const element = dataset.data[index];
              const element2 = dataset.data[index + 1];
              var gradient = ((element2.y - element.y) / 500) * 100;
              let color = "purple";
              if (gradient < 0) {
                color = "#cccccc";
              } else if (gradient < 6) {
                color = "blue";
              } else if (gradient < 8) {
                color = "green";
              } else if (gradient < 10) {
                color = "yellow";
              } else if (gradient < 12) {
                color = "orange";
              } else if (gradient < 15) {
                color = "red";
              }

              if (index == 0) {
                gradientFill.addColorStop(0, color);
              } else {
                gradientFill.addColorStop(index / dataset.data.length, color);
              }
              gradientFill.addColorStop(
                (index + 1) / dataset.data.length,
                color
              );
            }
            gradientFill.addColorStop(1, "red");

            var model =
              x.data.datasets[0]._meta[Object.keys(dataset._meta)[0]].dataset
                ._model;
            model.backgroundColor = gradientFill;
          },
        },
      ],
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/util/profileChart.js